import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from "@angular/core";
import { FormBuilder } from '@angular/forms';
import { SetupType, SetupTypeLabel } from "src/app-client/_appCommon/base/AppInterfaceAndBaseClasses";
import { PrescriptionDataService } from "src/app-client/_dataservices/PrescriptionDataService";
import { FormTools } from "src/shared/util/FormTools";
import { ActivatedRoute } from '@angular/router';
import { BroadcastManager } from "src/app-client/_appCommon/base/BroadcastManager";
import { AppEventNames } from "src/app-client/_appCommon/base/Constants";
import { takeUntil } from 'rxjs/operators';
import { Subject } from "rxjs";
import { SetupDataService } from "src/app-client/_dataservices/SetupDataService";

@Component({
  selector: 'app-client-first-step',
  templateUrl: './first-step.component.html',
  styleUrls: ['../crud-prescription.component.css']
})
export class FirstStepComponent extends FormTools implements OnChanges
{
  public prescriptionNumber = 1;
  public isCaseDetail: boolean;
  public formStep1Valid: boolean = false;
  private unsubscribe: Subject<void> = new Subject();

  @Input('prescriptionData') public prescriptionData! : any;

  @Output()
  public setupTypeChange = new EventEmitter<number>();

  public setupOptions = [
    { value: SetupType.Both, display: SetupTypeLabel.get(SetupType.Both) },
    { value: SetupType.Upper, display: SetupTypeLabel.get(SetupType.Upper) },
    { value: SetupType.Lower, display: SetupTypeLabel.get(SetupType.Lower) },
  ];

  constructor(
    formBuilder: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private prescriptionDataService: PrescriptionDataService,
    private setupDataService:SetupDataService)
  {
    super(10, formBuilder);
  }


  ngOnChanges(changes: SimpleChanges): void {  
    if(changes['prescriptionData']){
      this.stepFormGroup?.controls['setupType'].setValue(changes['prescriptionData'].currentValue.setupType);
      if (this.stepFormGroup) {
        if (this.stepFormGroup?.controls['setupType'].value!=-1) {
          BroadcastManager.Instance.broadcast("step1Valid", true);
        }
        else {
          BroadcastManager.Instance.broadcast("step1Valid", false);
        }
      }
    } 
  }

  ngOnInit(): void
  {
    this.activatedRoute.url.subscribe( url =>
    {
      this.isCaseDetail = url.toString().contains('detail');
    });
    

    BroadcastManager.Instance.on(AppEventNames.onUpdatePrescriptionStepByNumber)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(([e]) =>
      {
        let number = e[0];

        if (number && this.prescriptionNumber == number)
          this.updateStepPrescription();
      });

    this.stepFormGroup = this.formBuilder.group({
      id: [0, null],
      setupType: [null, null]
    });

    BroadcastManager.Instance.on("step1Valid")
    .pipe(takeUntil(this.unsubscribe))
    .subscribe(([data]: any) =>
    {
      this.formStep1Valid = data[0];
    });
    
  }

  ngOnDestroy(): void
  {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  public onChangeOption(event: any): void
  {
    this.setupTypeChange.emit(event.value);
    this.checkValidForm(event.value);
  }

  public checkValidForm(newValue)
  {
    if (this.stepFormGroup) {
      if (newValue!=-1) {
        BroadcastManager.Instance.broadcast("step1Valid", true);
      }
      else {
        BroadcastManager.Instance.broadcast("step1Valid", false);
      }
    }
    
  }

  public updateStepPrescription(): void
  {
    // Set prescriptionId in stepFormGroup
    this.stepFormGroup.controls['id'].setValue(this.GetPrescriptionId);

    this.prescriptionDataService.updatePrescriptionStep(this.GetSetupId, this.prescriptionNumber, this.stepFormGroup.value)
      .subscribe((response) =>
      {
        let body = 
        {
          id: this.GetSetupId,
          currentStep: 5
        }
        this.updateSetupCurrentStep(body);
        this.setSuccessAlert('Paso guardado correctamente');
      }, fail =>
      {
        this.setWarningAlert('Hubo un error al actualizar la prescripción: '+ fail.error.message);
      });
  }

  public disabledButtonStages():boolean
  {
    if(!this.formStep1Valid)
    {
      return true;
    }
    return false;
  }

  private updateSetupCurrentStep(body: any)
  {

    this.setupDataService.updateSetupCurrentStep(body)
    .subscribe(()=>
    {
      this.setCurrentSetupStep(body.currentStep);
    });
  }
}
